module.exports = __webpack_public_path__ + "static/media/joystick.323514f5.svg";